import { cloneDeep } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { PATTERNS_FILTER, sendingsOutputFilter, serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services.patterns,

      async inputFilter(result) {
        result.OwnerId = result?.Owner?.id || result?.OwnerId

        if (!Array.isArray(result.conditions)) {
          result.conditions = []
        }

        return result
      },

      outputFilter: sendingsOutputFilter,

      find: { defaultFilter: cloneDeep(PATTERNS_FILTER) },

      width: 600,
      formClass: ''
    })
  ]
}
